import { HttpInterceptorHandler } from "./interceptor";
export function interceptingHandler(backend) {
  var interceptors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!interceptors) {
    return backend;
  }
  return interceptors.reduceRight(function (next, interceptor) {
    return new HttpInterceptorHandler(next, interceptor);
  }, backend);
}
export { HttpBackend, HttpHandler } from "./backend";
export { HttpClient } from "./client";
export { HttpHeaders } from "./headers";
export { HttpInterceptorHandler } from "./interceptor";
// export {JsonpClientBackend, JsonpInterceptor} from './jsonp';
// export {HttpClientJsonpModule, HttpClientModule, HttpClientXsrfModule, HttpInterceptingHandler as ɵHttpInterceptingHandler} from './module';
export { HttpParams, HttpUrlEncodingCodec } from "./params";
export { HttpRequest } from "./request";
export { HttpErrorResponse, HttpEventType, HttpHeaderResponse, HttpResponse, HttpResponseBase } from "./response";
export { HttpXhrBackend, BrowserXhr, XhrFactory } from "./xhr";
// export {HttpXsrfTokenExtractor} from './xsrf';

export { Http, MessageError, isMessageError, NetworkError, isNetworkError, ResponseStatusError, isResponseStatusError, resolveResponseError } from "./http";
export { xhrHandler, xhrClient, http } from "./default";